module.exports = __webpack_public_path__ + "img/intro-banner-2-flip.37a1b3e9.png";